import React from 'react';
import { factoryExpenseListMeta } from '../../constants/factoryExpenseCategories';
import { EXPENSE_CATEGORY_VALUES } from '../../constants/expenseCategories';
import { useLanguage } from '../../i18n/LanguageContext';
import ExpenseCategoryList from './ExpenseCategoryList';

const BossExpenses = ({ user, onAddExpense }) => {
  const { t, lang } = useLanguage();
  const meta = factoryExpenseListMeta(EXPENSE_CATEGORY_VALUES.BOSS, user, lang);
  return (
    <ExpenseCategoryList
      user={user}
      category="boss"
      title={meta?.title || t('exp.list.boss.title')}
      lede={meta?.lede || t('exp.list.boss.lede')}
      onAddExpense={onAddExpense}
    />
  );
};

export default BossExpenses;
